import React, { createContext, useContext, useState } from 'react';

import {
  TTenantContext,
  TTenantProviderProps,
} from '@/shared/features/auth/context/tenant-context.types';
import { useAppSyncEvents } from '@/shared/hooks/use-appsync-events/use-app-sync-events';
import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

const TENANT_SWITCH_EVENT_NAME = 'IDENT_TENANT_SWITCHED';

const TenantContext = createContext<TTenantContext | undefined>(undefined);

export const useTenant = () => {
  const context = useContext(TenantContext);
  if (!context) {
    throw new Error('useTenant must be used within TenantProvider');
  }
  return context;
};

export const TenantProvider = ({ children }: TTenantProviderProps) => {
  const user = useAppSelector(selectUser);
  const tenantId = user?.attributes?.['custom:tenantId'];
  const webSocketChannel = `default/${tenantId}/ident/user/${user?.userId}`;
  const [open, setOpen] = useState(false);

  const { disconnect } = useAppSyncEvents({
    webSocketChannel,
    connectOnInit: Boolean(tenantId),
    onMessageReceived: (data) => {
      if (data.event.operation_type !== TENANT_SWITCH_EVENT_NAME) {
        return;
      }

      setOpen(true);
    },
  });

  const value: TTenantContext = {
    openTenantSwitchInfo: open,
    disconnect,
  };

  return <TenantContext value={value}>{children}</TenantContext>;
};
